module.exports = __webpack_public_path__ + "img/tor_3.5f7145bc.webp";